(function () {
    // The shared URL gets utm_source/utm_medium appended so traffic that
    // comes back through a share is attributable in Umami -- see
    // OneDrive/Desktop/aleph/umami-guide.html for the same convention
    // used for ad-hoc campaign links. Web Share API never tells us which
    // app the person actually picked (by design, for privacy), so every
    // native share uses one shared "native_share" source rather than a
    // per-network breakdown.
    const withUtm = function (url, source) {
        const u = new URL(url);
        u.searchParams.set('utm_source', source);
        u.searchParams.set('utm_medium', 'share');
        return u.toString();
    };

    // execCommand first, not the async Clipboard API -- writeText() can
    // reject with "Document is not focused" in perfectly ordinary
    // situations (confirmed live), which made the old copy-link button
    // look like it silently did nothing on some clicks.
    const execCommandCopy = function (text) {
        const input = document.createElement('textarea');
        input.value = text;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.focus();
        input.select();
        let ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(input);
        return ok;
    };

    const showTooltip = function (btn, ok) {
        const tooltip = btn.parentElement.querySelector('.article-share-tooltip');
        btn.classList.toggle('is-copied', ok);
        if (tooltip) {
            tooltip.textContent = ok ? 'Скопировано' : 'Не удалось скопировать';
            tooltip.classList.add('is-visible');
        }
        setTimeout(function () {
            btn.classList.remove('is-copied');
            if (tooltip) tooltip.classList.remove('is-visible');
        }, 1800);
    };

    const copyFallback = function (text, btn) {
        if (execCommandCopy(text)) {
            showTooltip(btn, true);
            return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(
                function () { showTooltip(btn, true); },
                function () { showTooltip(btn, false); }
            );
            return;
        }
        showTooltip(btn, false);
    };

    document.querySelectorAll('.article-share').forEach(function (container) {
        const baseUrl = container.getAttribute('data-share-url');
        const title = container.getAttribute('data-share-title') || '';
        const btn = container.querySelector('.article-share-btn');
        if (!baseUrl || !btn) return;

        btn.addEventListener('click', function () {
            if (navigator.share) {
                navigator.share({
                    title: title,
                    url: withUtm(baseUrl, 'native_share'),
                }).catch(function (err) {
                    // AbortError just means the person closed the share
                    // sheet without picking anything -- not a failure.
                    if (err && err.name === 'AbortError') return;
                    copyFallback(withUtm(baseUrl, 'copy_link'), btn);
                });
                return;
            }
            // No Web Share API (most desktop browsers) -- copy the link
            // instead, same visible feedback as the share sheet path's
            // own error fallback above.
            copyFallback(withUtm(baseUrl, 'copy_link'), btn);
        });
    });
})();
